import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useUniversalSearch } from "./hooks/useUniversalSearch";
import { PSearch } from "./PSearch";
import { useOnboarding } from "@/providers/OnboardingProvider";

export const GlobalSearch = () => {
  const pathname = useLocation().pathname;
  const isAuthRoute = pathname.startsWith("/auth");
  const { popupRef, isUniversalSearchOpen, setIsUniversalSearchOpen } =
    useUniversalSearch(isAuthRoute);
  const { completeStep } = useOnboarding();

  // Complete onboarding step when user opens the command palette
  useEffect(() => {
    if (isUniversalSearchOpen) {
      completeStep("discover_quick_search");
    }
  }, [isUniversalSearchOpen, completeStep]);

  // Listen for open event from sidebar SearchButton
  useEffect(() => {
    if (isAuthRoute) return;

    const handleOpen = () => {
      setIsUniversalSearchOpen(true);
    };

    window.addEventListener("openGlobalSearch", handleOpen);
    return () => {
      window.removeEventListener("openGlobalSearch", handleOpen);
    };
  }, [isAuthRoute, setIsUniversalSearchOpen]);

  if (isAuthRoute) return null;

  return (
    <AnimatePresence>
      {isUniversalSearchOpen && (
        <PSearch
          popupRef={popupRef}
          setIsSearchPopupOpenAction={setIsUniversalSearchOpen}
        />
      )}
    </AnimatePresence>
  );
};
